import React, { Component } from "react";

class EmailVerificationConfirmation extends Component {
  componentDidMount() {
  }
  render() {
    return (
    <section className="sectionContent"><div className="page">
    <header><h2>Email Verification Confirmation</h2></header>  
<div className="pageContent"></div>
    </div></section>);
  }
}

export default EmailVerificationConfirmation;
